import { useEffect, useRef } from "react";

const INACTIVITY_LIMIT = 30 * 60 * 1000; // 30 minutes

export default function useAutoLogout(logout) {
  const timerRef = useRef(null);

  const resetTimer = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    timerRef.current = setTimeout(() => {
      logout();
    }, INACTIVITY_LIMIT);
  };

  useEffect(() => {
    const events = [
      "mousemove",
      "mousedown",
      "keydown",
      "scroll",
      "touchstart"
    ];

    events.forEach(event =>
      window.addEventListener(event, resetTimer)
    );

    // Start timer initially
    resetTimer();

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }

      events.forEach(event =>
        window.removeEventListener(event, resetTimer)
      );
    };
  }, []);
}
